// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"fecd0307","53":"c9607587","537":"54831398"}[chunkId] + ".chunk.js";
};